import { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
export const SECRET_KEY = "revolution";

export function encryptUrl(key: string) {
  let encryptedKey = CryptoJS.AES.encrypt(key, SECRET_KEY).toString();
  return encodeURIComponent(encryptedKey);
}

function useDecryptedParams(params: any) {
  const [decryptedParams, setDecryptedParams] = useState<any>({});

  useEffect(() => {
    try {
      if (params) {
        Object.keys(params).forEach((key) => {
          if (key !== "*" && params[key] !== "") {
            let encryptedKey = CryptoJS.AES.decrypt(
              decodeURIComponent(params[key]),
              SECRET_KEY
            ).toString(CryptoJS.enc.Utf8);
            if (encryptedKey) {
              params[`${key}`] = encryptedKey;
            }
            //console.log(CryptoJS.AES.decrypt('U2FsdGVkX19mcuO7dMw09jeih+CuuV8cIdJjn7hd+f8=', SECRET_KEY).toString(CryptoJS.enc.Utf8));
          }
        });
        setDecryptedParams(params);
      }
    } catch (error) {
      setDecryptedParams(params);
    }
  }, []);

  return [decryptedParams];
}

export default useDecryptedParams;
